import { render, staticRenderFns } from "./selected_results.vue?vue&type=template&id=530e37d6&"
import script from "./selected_results.vue?vue&type=script&lang=js&"
export * from "./selected_results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports